import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export const SummaryItem = ({
  title,
  value,
  titleClassName,
  className,
  titleWrapperClassName,
  semicolon = true,
}: {
  className?: false | string;
  semicolon?: boolean;
  title: ReactNode;
  titleClassName?: string;
  titleWrapperClassName?: string;
  value: number | ReactNode | string | undefined;
}) => (
  <div className={twMerge('flex w-full gap-3 py-3', className)}>
    <div className={twMerge('flex', titleWrapperClassName)}>
      <span
        className={twMerge(
          'w-[120px] flex-shrink-0 text-xs font-[450] text-gray-500',
          titleClassName,
        )}
      >
        {title}
      </span>
      {semicolon && <span className="text-xs font-[450] text-gray-500">:</span>}
    </div>
    <span className="w-full max-w-[250px] truncate text-xs font-[450] text-gray-700">
      {value ?? '-'}
    </span>
  </div>
);
